import type { ReactNode } from 'react'
import { Inbox, type LucideIcon } from 'lucide-react'
import { cn } from '../cn'

interface TableEmptyStateProps {
  message?: string
  children?: ReactNode
  className?: string
  icon?: LucideIcon
  title?: string
}

export function TableEmptyState({
  message,
  children,
  className,
  title,
  icon: Icon = Inbox,
}: TableEmptyStateProps) {
  return (
    <div
      className={cn(
        'border-border-divider flex min-h-40 items-center justify-center rounded-sm border border-dashed bg-card text-center',
        className
      )}
    >
      {children ?? (
        <div className='flex flex-col items-center gap-3'>
          <Icon className='text-text-placeholder h-7 w-7' />
          {title && (
            <h3 className='font-heading text-muted-foreground text-[14px] font-semibold'>
              {title}
            </h3>
          )}
          <p className='font-body text-muted-foreground text-[12px]'>
            {message}
          </p>
        </div>
      )}
    </div>
  )
}
